import tenantAsabet from './tenant-asabet.json';
import tenantBetnana from './tenant-betnana.json';
import tenantGugul from './tenant-gugul.json';
import tenantHazaratGame from './tenant-hazarat-game.json';
import tenantSkibet from './tenant-skibet.json';
import tenantVatanGame from './tenant-vatan-game.json';
import tenantXbet from './tenant-xbet.json';

export const TENANTS_DATA = [
  tenantVatanGame,
  tenantHazaratGame,
  tenantSkibet,
  tenantAsabet,
  tenantGugul,
  tenantXbet,
  tenantBetnana,
];
